<div
  class="fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-on-surface/50 backdrop-blur-sm p-0 sm:p-4"
  (click)="close()"
>
  <div
    class="bg-white w-full sm:max-w-md rounded-t-3xl sm:rounded-3xl p-6 sm:p-8 relative animate-[fadeIn_.2s_ease-out]"
    (click)="$event.stopPropagation()"
  >
    <button
      type="button"
      class="absolute top-4 right-4 text-on-surface-variant hover:text-on-surface"
      (click)="close()"
      aria-label="Cerrar"
    >
      <span class="material-symbols-outlined">close</span>
    </button>

    <div class="flex items-center gap-2 mb-6">
      <span class="material-symbols-outlined text-whatsapp-green" style="font-variation-settings: 'FILL' 1;">chat</span>
      <h2 class="text-headline-md">Entrar con WhatsApp</h2>
    </div>

    @if (step() === 'phone') {
      <p class="text-on-surface-variant text-sm mb-4">
        Te enviaremos un código de verificación por WhatsApp.
      </p>
      <div class="flex gap-2 mb-4">
        <select
          class="rounded-xl border border-outline-variant px-3 py-3 text-sm bg-white"
          [ngModel]="countryDial()"
          (ngModelChange)="countryDial.set($event)"
          aria-label="Código de país"
        >
          @for (pais of paises; track pais.code) {
            <option [value]="pais.dial">{{ pais.flag }} {{ pais.code }} ({{ pais.dial }})</option>
          }
        </select>
        <input
          type="tel"
          class="flex-1 rounded-xl border border-outline-variant px-4 py-3 text-sm focus:border-primary focus:outline-none"
          placeholder="55 1234 5678"
          [ngModel]="phoneNumber()"
          (ngModelChange)="phoneNumber.set($event)"
          aria-label="Número de WhatsApp"
        />
      </div>
      @if (error()) {
        <p class="text-error text-sm mb-4">{{ error() }}</p>
      }
      <button
        type="button"
        class="btn-whatsapp w-full"
        [disabled]="loading()"
        (click)="sendOtp()"
      >
        <span class="material-symbols-outlined" style="font-variation-settings: 'FILL' 1;">send</span>
        {{ loading() ? 'Enviando…' : 'Enviar código' }}
      </button>
    } @else {
      <p class="text-on-surface-variant text-sm mb-4">
        Ingresa el código de 6 dígitos que enviamos a {{ fullPhone }}.
      </p>
      <input
        type="text"
        inputmode="numeric"
        maxlength="6"
        class="w-full rounded-xl border border-outline-variant px-4 py-3 text-sm text-center tracking-[0.5em] font-mono mb-4 focus:border-primary focus:outline-none"
        placeholder="000000"
        [ngModel]="otpCode()"
        (ngModelChange)="otpCode.set($event)"
        aria-label="Código de verificación"
      />
      @if (error()) {
        <p class="text-error text-sm mb-4">{{ error() }}</p>
      }
      <button type="button" class="btn-primary w-full mb-3" [disabled]="loading()" (click)="verifyOtp()">
        {{ loading() ? 'Verificando…' : 'Verificar código' }}
      </button>
      <button type="button" class="text-primary text-sm underline w-full text-center" (click)="backToPhone()">
        Cambiar número
      </button>
    }
  </div>
</div>
